module.exports = __webpack_public_path__ + "img/Logo-format-Twitter.716db261.jpg";